/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class ResultInformation {
  ManufacturerResult!: string;
  NameResult!: string;
  ImagePath!: string;
  Image!: string;
  Path!: string;
  Discipline!: Discipline;
  FittingId!: number;
  FittingIdNumber!: string;
  sizes?:any;
}

export  enum Discipline {
  None,
  PlumbingPiping,
  Electrical,
  SheetMetal,
  Mep,
  Discontinued,
  CableTray,
  Hangers,
}
